import Grid from "@mui/material/Grid2";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useContext, useEffect, useState } from "react";
import Contents from "./Contents";
import Index from "./Index"
import Search from "./Search"
import Paper from "@mui/material/Paper";
import { APIContext } from '../Contexts/APIContext';
import { useLocation } from "react-router-dom";


export default function Help() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const page = params.get('page');

    const [value, setValue] = useState(0);
    const [files, setFiles] = useState<FileNodeViewModel[]>([]);
    const [selectedFile, setSelectedFile] = useState<string | null>(null);

    const steps = [Contents, Index, Search];
    const { get } = useContext(APIContext);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedFile(null);
        setValue(newValue);
    };

    const init = (data) => {
        setFiles(data);
        if (page != null) {
            const results: FileNodeViewModel[] = [];
            const stack: FileNodeViewModel[] = [...data]; 
            while (stack.length > 0) {
                const node = stack.pop()!;

                if (node.fileContent !== null) {
                    results.push(node);
                }

                if (node.children && node.children.length > 0) {
                    stack.push(...node.children);
                }
            }
            const file = results.find(f => f.label.toLowerCase() == page.toLowerCase())
            if (file) {
                setSelectedFile(file.fileContent);
            }
        }
    };

    useEffect(() => {
        get('Document', 'GetHelpFiles', init);
    }, []);

    useEffect(() => {
        if (page != null) {
            setValue(1);
        }
    }, [page]);

    const CurrentStepComponent = steps[value];

    return (
        <Grid container style={{ height: "calc(100vh - 98px)" }}>
            <Grid size={4} style={{ height: "100%" }}>
                <Paper style={{
                    height: "100%",
                    overflow: "auto",
                    padding: "16px",
                    scrollbarWidth: "thin",
                }}>
                    <Grid pb={1}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label="Contents" />
                            <Tab label="Index" />
                            <Tab label="Search" />
                        </Tabs>
                    </Grid>
                    <Grid>
                        <CurrentStepComponent files={files} setSelectedFileContent={setSelectedFile} />
                    </Grid>
                </Paper>
            </Grid>
            <Grid size={8} style={{ height: "100%" }}>
                <Paper style={{
                    height: "100%",
                    overflow: "auto",
                    padding: "16px",
                    scrollbarWidth: "thin",
                }}>
                    {
                        selectedFile && <div dangerouslySetInnerHTML={{ __html: selectedFile }} />
                    }
                </Paper>
            </Grid>

        </Grid>
    );
}
